import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import { BehaviorSubject, finalize, switchMap } from 'rxjs';
import { PortfolioPaper } from '../../../_shared/model';
import { DocumentsService } from '../../pages/home/_services';

@Component({
    selector: 'app-rename-paper-popup',
    templateUrl: './rename-paper-popup.component.html',
    styles: [],
})
export class RenamePaperPopupComponent {
    @Input() contractorId: number;
    @Input() set paper(paper: PortfolioPaper) {
        this.fcFileName.setValue(paper.customName);
        this.paperSubject.next(paper);
    }

    public fcFileName = new FormControl(null, [Validators.required]);
    public isLoading$ = new BehaviorSubject<boolean>(false);
    public paperSubject = new BehaviorSubject<PortfolioPaper>(null);

    constructor(
        public activeModal: NgbActiveModal,
        public documentService: DocumentsService,
    ) {}

    public onRenameClick(): void {
        this.isLoading$.next(true);
        this.paperSubject
            .pipe(
                switchMap(paper => {
                    const paperId = paper.paperId ? paper.paperId : paper.id;
                    return this.documentService.renamePaper(this.contractorId, paperId, _.trim(this.fcFileName.value));
                }),
                finalize(() => {
                    this.isLoading$.next(false);
                }),
            )
            .subscribe(() => {
                this.activeModal.close();
            });
    }
}
